module.exports = __webpack_public_path__ + "static/media/our-promise.c7c5f19d.jpg";